import ExchangeInfo from "./ExchangeInfo";

export default ExchangeInfo;
